<template>
	<div class="itempage" style="background: #fff;">
		<el-card style="position: relative;padding-bottom: 10px;">
			<div style="font-size: 20px;font-weight: bold;color: #4b92ff;">{{ title_number }}</div>
			<div style="font-size: 16px;"><b>{{ title_subClass }}</b></div>
			<span style="font-size: 28px;position: absolute;right: 50px;top: 38%;">{{ title_currentStatus }}</span>
			<div style="margin-left: 20px;position: absolute;right: 22%;top: 38%;">
			</div>
		</el-card>

		<div style="margin-top: 10px;">
			<!--<el-button icon="el-icon-document-delete" size="small" style="margin-left: 10px;">浏览器</el-button> -->
			<el-dropdown placement="bottom" style="margin-left: 10px" @visible-change="checkDelPriv">
				<el-button size="small">
					{{ $t('message.button.actions') }}<i class="el-icon-arrow-down el-icon--right"></i>
				</el-button>

				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item @click.native="saveAs = true">{{ $t('message.button.saveAs') }}</el-dropdown-item>
					<el-dropdown-item @click.native="addFavorite">{{ $t('message.button.bookmark') }}</el-dropdown-item>
					<el-dropdown-item @click.native="removeFavorite">{{ $t('message.button.cancelBookmark')
					}}</el-dropdown-item>
					<el-dropdown-item :disabled="!deletePriv" @click.native="deleteItem">{{ $t('message.button.delete') }}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>

		<el-dialog v-if="saveAs" class="searchAddBomList" :title="$t('message.title.saveAs')" :visible.sync="saveAs"
			:close-on-click-modal="!saveAs">
			<!-- <searchAdd @listDbClick="addList"></searchAdd> -->
			<save-as-form @close="cancelSaveAs"></save-as-form>
		</el-dialog>

		<!-- tab切换 -->
		<div class="content">
			<div class="content-title">
				<div @click="tabClick(item, index)" class="content-item" :class="{ active: index == num }"
					v-for="(item, index) in tabList" :key="index">
					<div style="display: flex;">
						<div>
							{{ item.name }}
						</div>
						<div :style="{ 'visibility': item.isResult ? 'visible' : 'hidden', }"
							style=" margin-left: 3px;font-size: 22px;">*</div>
					</div>
				</div>
			</div>
			<div style="height: 6px;background: #ebebeb;"></div>
			<div class="route-content">
				<router-view :changeValue='change_to_child' :updateWorkflow='updateWorkflowTable' :relUrl='relUrl'
					:type='manufacturer' @routeClick='reload'></router-view>
			</div>
		</div>
	</div>

</template>

<style scoped>
.route-content {
	padding: 10px 15px;
	height: calc(100vh - 332px);
	overflow-y: scroll;
}

.content-title {
	display: flex;
	gap: 20px;
	padding-left: 20px;
	margin-top: 8px;

	.content-item {
		padding: 8px 15px;
		font-size: 16px;
		cursor: pointer;

		&:hover {
			border-bottom: 3px solid #4b92ff;
			color: #4b92ff;
		}

		&.active {
			border-bottom: 3px solid #4b92ff;
			color: #4b92ff;
		}
	}
}

.tableBtn {
	position: absolute;
	bottom: 0;
	right: 0;
}

.table-list2 {
	overflow: auto;
	margin-top: 4px;
}

.table-list2 .list-key {
	display: inline-block;
	width: 22%;
	text-align: right;
	font-size: 14px;
	line-height: 40px;
	float: left;
}

.table-list2 .list-val {
	display: inline-block;
	width: 60%;
	overflow: hidden;
}
</style>

<script>
import axios from "axios";
import SaveAsForm from '../common/saveAsFormForCommon.vue';
import { manufacturerTabList } from "@/utils/publicstate";
import { getTabIndex } from "@/utils/index.js"

export default {
	name: 'manufactPage',
	data() {
		return {
			input_width: {
				width: "96%"
			},

			relUrl: 'manufacturers',
			base: '',
			manufacturer: 'manufacturer',

			statusInfo: [],	//状态信息
			status: "",		//当前状态
			workflowId: "",	//当前工作流

			changeInfo_All: [],//change的所有信息
			change_value: "0",//change选中的信息
			change_to_child: "",//向子组件传送change信息
			updateWorkflowTable: "",//向子组件传送change信息

			title_number: "",
			title_subClass: "",
			title_description: "",
			title_currentStatus: "",
			title_currentStatusId: "",
			title_currentStatusType: "",
			title_nextStatusId: "",
			title_nextStatusType: "",
			title_workflowId: "",
			page_one: [],
			tabList: [],
			loading: true,
			deletePriv: false,
			version: "",
			signoffButton: true,
			userInfo: {},
			approveWindow: false,
			rejectWindow: false,
			signoffComments: "",
			currentUserId: "",
			currentUserLoginId: "",

			objInfo: { ...this.$store.state.objectId },

			saveAs: false
		}
	},
	computed: {
		num() {
			return this.tabList.findIndex(i => i.path == this.$route.path)
		}
	},
	mounted() {
	},
	components: { SaveAsForm },
	methods: {
		cancelSaveAs() {
			this.saveAs = false
		},
		removeFavorite() {
			// console.log("removeFavorite");
			this.removeFavoriteInCommon(
				{
					baseClassId: this.Constants.manufactureBaseClassId,
					number: this.title_number,
					id: this.$store.state.objectId.id
				}
			);
		},
		reload(e) {
			if (e == undefined) {
				this.logoInfo();
				return
			}
			const obj = {
				id: e.itemId,
				classId: e.itemClassId,
				subClassId: e.itemSubClassId,
				title: e[0]
			};
			this.getLink(obj);
		},
		checkDelPriv(e) {
			console.log(e);
			if (e) {
				const arr = JSON.parse(sessionStorage.getItem('userContext')).privs;
				const privsArr = arr.map(i => { return i.type })
				if (privsArr.indexOf(25) != -1) {
					this.deletePriv = true;
				}
			}
		},
		deleteItem() {
			this.$confirm(this.$t('message.confirm.deleteObject'), this.$t('message.tips.tip'), {
				confirmButtonText: this.$t('message.button.affirm'),
				cancelButtonText: this.$t('message.button.cancel'),
				type: "warning",
			})
				.then(() => {
					let obj = {
						//subClassId: this.$store.state.subClassId_,
						... this.$store.state.objectId,
						//id: this.$store.state.objectId.id,
						//classId: this.$store.state.classId_,
					};
					axios
						.get(`/pmdm/manufacturers/deleteManufacturerP1${this.params(obj)}`)
						.then((res) => {
							if (res.data.code == 200) {
								this.$message.success(res.data.message);
								this.$emit("deletePage", this.title_number);
							} else {
								this.$message({
									type: "info",
									message: this.$t('message.error.delete'),
								});
							}
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: this.$t('message.tips.deleteCancel'),
					});
				});
		},
		addFavorite() {
			// console.log("addFavorite");
			this.addFavoriteInCommon(
				{
					baseClassId: this.Constants.manufactureBaseClassId,
					number: this.title_number,
					id: this.$store.state.objectId.id
				}
			);
		},


		tabClick(res, index) {

			this.$store.commit("setTabID", { index, ...this.objInfo });
			const item = this.tabList[index]

			this.$router.push({
				path: item.path,
				query: { ...this.$store.state.objectId },
			});
			this.$store.commit('setTabIndex', { ...this.$store.state.objectId, index })

		},

		getTab() {
			this.$http.get("/pmdm/admin/getTab/1050101").then(res => {
				this.tabList = res.data.object.tabs.map(i => {
					i.path = manufacturerTabList.find(j => j.id == i.id).path
					return i;
				})
				const tabIndex = getTabIndex({ ...this.$store.state.objectId })?.index || 0
				this.tabClick(manufacturerTabList.find(j => j.id == this.tabList[tabIndex].id), tabIndex)

			})
		},
		async logoInfo() {


			var obj_get = { //获取change
				... this.$store.state.objectId,
				tableId: 1
			};
			var loadTableUrl = `/pmdm/manufacturers/loadTable${this.params(obj_get)}`;
			const {//获取标题
				data: res2
			} = await this.$http.get(loadTableUrl);
			if (res2.code !== 200)
				return this.$message.error(res.message);
			//console.log(res2);
			this.page_one = this.getNewData(res2.object.table.columnInfo);
			var val_ = res2.object.table.rows[0].cells;
			//console.log(this.page_one);
			//console.log(val_);
			for (var i = 0; i < this.page_one.length; i++) {
				this.page_one[i].val = val_[i];
				if (this.page_one[i].id == 1011001) {
					this.title_number = this.page_one[i].val.val;
					// this.updateTabName(this.title_number);
				}
				if (this.page_one[i].id == 1011002) {
					this.title_currentStatus = this.page_one[i].val.val;
				}
				if (this.page_one[i].id == 1011005) {
					this.title_description = this.page_one[i].val.val;
				}
				if (this.page_one[i].id == 1011003) {
					this.title_subClass = this.page_one[i].val.val;
				}
				if (this.page_one[i].id == 1011008) {
					this.title_workflowId = this.page_one[i].val.id;
				}
			};


			//添加最近访问
			//console.log(this.$store.state.objectId.id);
			this.addRecentVistInCommon(
				{
					baseClassId: this.Constants.manufactureBaseClassId,
					number: this.title_number,
					id: this.$store.state.objectId.id
				}
			);

			this.updateFavoriteInCommon(
				{
					baseClassId: this.Constants.manufactureBaseClassId,
					number: this.title_number,
					id: this.$store.state.objectId.id
				}
			);
		},


	},
	created() {
		const { id, classId, subClassId } = this.$route.query;
		const obj = { id, classId, subClassId };
		this.$store.commit('setObjectId', obj);
		this.getTab();
		this.userInfo = this.$store.state.userInfo;
		this.logoInfo();

	}
}
</script>
